export default {
    agreement_categories: "Категории согласий",
    app_code: "Код приложения-инициатора",
    authentication_login: "Логин аутентификации",
    authentication_password: "Пароль аутентификации",
    cod_no: "Код НО",
    credentials_of_authorized_person: "Авторизация уполномоченного лица",
    director: "Директор",
    do_you_confirm_sending_feedback_url_to_patient_messenger: "Подтверждаете отправку ссылки на написание отзыва пациенту в мессенджер?",
    do_you_confirm_sending_receipt_to_patient_messenger: "Подтверждаете отправку квитанции пациенту в мессенджер?",
    employee_login: "Логин сотрудника",
    employee_password: "Пароль сотрудника",
    fdoc_instruction: "Для корректной работы услуги передайте менеджеру FDoc IP-адрес, на который вы будете получать хуки/запросы: <code>{ipaddress}</code>. Также назовите события, которые хотите получать: <code>SetStatus, SetStatusMessage, SetStatusPackageByClient</code>",
    fdoc_multiple_signers_instruction: "В разделе персонал в редактировании сотрудника во вкладке FDoc должны быть указаны логин и пароль сотрудника от системы FDoc.",
    files: "Файлов",
    files_being_uploaded: "Идет загрузка файлов. Не закрывайте страницу, пока загрузка не завершится.",
    fill_questionary: "Заполнить анкету",
    first_new: "Сначала новые",
    first_old: "Сначала старые",
    gallery: "Галерея",
    header_in_akt: "Шапка в акте оказанных услуг",
    multiple_signers_support: "Поддержка нескольких подписантов",
    options: "Опции",
    or_folder_with_dcm_files: "или папку с DCM-файлами",
    select_folder: "Выберите папку",
    send_receipt_to_messenger: "Отправить квитанцию в мессенджер пациента",
    sign_selected_via_vendor: "Подписать выбранные через {vendor}",
    table: "Таблица"
}
